export const config = {
  api_monmi : "https://client-monmi.myepis.cloud",
  api_monmi_local : "http://localhost:8010/proxy",
  api_gateway : "https://monmi-gateway.myepis.cloud",
  x_monmi_api : 123,
  cartFake: [
    {
      product: {
        slug: "phatss",
        merchant_id: "61c5e049fa8078171700171b",
        category_id: "61c5e0cffa80781717001746",
        price: 100000,
        status: 1,
        image_id: "61c5e0e3fa80781717001754",
        image_ids: [],
        description: "ohatfb",
        name: "Sản phẩm 1 shop 1",
        created_at: "2021-12-24T15:01:56.916Z",
        updated_at: "2021-12-24T15:01:56.916Z",
        code: 44,
        image: {
          merchant_id: "61c5e049fa8078171700171b",
          is_local: false,
          mimetype: "image/jpeg",
          path: "https://monmi.hn.ss.bfcplatform.vn/merchants/61c5e049fa8078171700171b/1640358114908-1.jpg",
          name: "1.jpg",
          created_at: "2021-12-24T15:01:55.179Z",
          updated_at: "2021-12-24T15:01:55.179Z",
          id: "61c5e0e3fa80781717001754"
        },
        images: [],
        id: "61c5e0e4fa8078171700175b"
      },
      merchant: {
        slug: "phat-lac-long-quan-phuong-12-quan-tan-binh-ho-chi-minh-1640357961557",
        deliveries: [],
        location: {
          position: {type: "Point", coordinates: [106.6474366, 10.7740344]},
          lat: 10.818241,
          long: 106.723344,
          address: "lac long quan ",
          province_name: "Hồ Chí Minh",
          district_name: "Quận Tân Bình",
          ward_name: "Phường 12",
          ward_id: 21412,
          district_id: 1455,
          province_id: 202,
          created_at: "2021-12-24T14:59:21.562Z",
          updated_at: "2021-12-24T14:59:21.562Z"
        },
        status: 1,
        is_verified: 1,
        description: "phat",
        phone: "+614848494945",
        email: "vcs.epis@gmail.com",
        name: "phat",
        created_at: "2021-12-24T14:59:21.563Z",
        updated_at: "2021-12-24T14:59:21.700Z",
        code: 44,
        merchant_id: "61c5e049fa8078171700171b",
        image: null,
        categories: [{
          slug: "hus-1640358095978",
          merchant_id: "61c5e049fa8078171700171b",
          status: 1,
          image_ids: [],
          description: "h",
          name: "hus",
          is_deleted: false,
          deleted_at: null,
          created_at: "2021-12-24T15:01:35.979Z",
          updated_at: "2021-12-24T15:01:35.979Z",
          code: 22,
          products: [{
            slug: "phatss",
            merchant_id: "61c5e049fa8078171700171b",
            category_id: "61c5e0cffa80781717001746",
            price: 100000,
            status: 1,
            image_id: "61c5e0e3fa80781717001754",
            image_ids: [],
            description: "ohatfb",
            name: "phatss",
            created_at: "2021-12-24T15:01:56.916Z",
            updated_at: "2021-12-24T15:01:56.916Z",
            code: 44,
            image: {
              merchant_id: "61c5e049fa8078171700171b",
              is_local: false,
              mimetype: "image/jpeg",
              path: "https://monmi.hn.ss.bfcplatform.vn/merchants/61c5e049fa8078171700171b/1640358114908-1.jpg",
              name: "1.jpg",
              created_at: "2021-12-24T15:01:55.179Z",
              updated_at: "2021-12-24T15:01:55.179Z",
              id: "61c5e0e3fa80781717001754"
            },
            images: [],
            id: "61c5e0e4fa8078171700175b"
          }],
          images: [],
          id: "61c5e0cffa80781717001746"
        }],
        id: "123"
      },
      qty: 2
    },
    {
      product: {
        slug: "phatss",
        merchant_id: "61c5e049fa8078171700171b",
        category_id: "61c5e0cffa80781717001746",
        price: 100000,
        status: 1,
        image_id: "61c5e0e3fa80781717001754",
        image_ids: [],
        description: "ohatfb",
        name: "Sản phẩm 2 shop 1",
        created_at: "2021-12-24T15:01:56.916Z",
        updated_at: "2021-12-24T15:01:56.916Z",
        code: 44,
        image: {
          merchant_id: "61c5e049fa8078171700171b",
          is_local: false,
          mimetype: "image/jpeg",
          path: "https://monmi.hn.ss.bfcplatform.vn/merchants/61c5e049fa8078171700171b/1640358114908-1.jpg",
          name: "1.jpg",
          created_at: "2021-12-24T15:01:55.179Z",
          updated_at: "2021-12-24T15:01:55.179Z",
          id: "61c5e0e3fa80781717001754"
        },
        images: [],
        id: "61c5e0e4fa8078171700175b"
      },
      merchant: {
        slug: "phat-lac-long-quan-phuong-12-quan-tan-binh-ho-chi-minh-1640357961557",
        deliveries: [],
        location: {
          position: {type: "Point", coordinates: [106.6474366, 10.7740344]},
          lat: 10.818241,
          long: 106.723344,
          address: "lac long quan ",
          province_name: "Hồ Chí Minh",
          district_name: "Quận Tân Bình",
          ward_name: "Phường 12",
          ward_id: 21412,
          district_id: 1455,
          province_id: 202,
          created_at: "2021-12-24T14:59:21.562Z",
          updated_at: "2021-12-24T14:59:21.562Z"
        },
        status: 1,
        is_verified: 1,
        description: "phat",
        phone: "+614848494945",
        email: "vcs.epis@gmail.com",
        name: "phat",
        created_at: "2021-12-24T14:59:21.563Z",
        updated_at: "2021-12-24T14:59:21.700Z",
        code: 44,
        merchant_id: "61c5e049fa8078171700171b",
        image: null,
        categories: [{
          slug: "hus-1640358095978",
          merchant_id: "61c5e049fa8078171700171b",
          status: 1,
          image_ids: [],
          description: "h",
          name: "hus",
          is_deleted: false,
          deleted_at: null,
          created_at: "2021-12-24T15:01:35.979Z",
          updated_at: "2021-12-24T15:01:35.979Z",
          code: 22,
          products: [{
            slug: "phatss",
            merchant_id: "61c5e049fa8078171700171b",
            category_id: "61c5e0cffa80781717001746",
            price: 100000,
            status: 1,
            image_id: "61c5e0e3fa80781717001754",
            image_ids: [],
            description: "ohatfb",
            name: "phatss",
            created_at: "2021-12-24T15:01:56.916Z",
            updated_at: "2021-12-24T15:01:56.916Z",
            code: 44,
            image: {
              merchant_id: "61c5e049fa8078171700171b",
              is_local: false,
              mimetype: "image/jpeg",
              path: "https://monmi.hn.ss.bfcplatform.vn/merchants/61c5e049fa8078171700171b/1640358114908-1.jpg",
              name: "1.jpg",
              created_at: "2021-12-24T15:01:55.179Z",
              updated_at: "2021-12-24T15:01:55.179Z",
              id: "61c5e0e3fa80781717001754"
            },
            images: [],
            id: "61c5e0e4fa8078171700175b"
          }],
          images: [],
          id: "61c5e0cffa80781717001746"
        }],
        id: "123"
      },
      qty: 4
    },
    {
      product: {
        slug: "phatss",
        merchant_id: "61c5e049fa8078171700171b",
        category_id: "61c5e0cffa80781717001746",
        price: 100000,
        status: 1,
        image_id: "61c5e0e3fa80781717001754",
        image_ids: [],
        description: "ohatfb",
        name: "Sản phẩm 1 shop 2",
        created_at: "2021-12-24T15:01:56.916Z",
        updated_at: "2021-12-24T15:01:56.916Z",
        code: 44,
        image: {
          merchant_id: "61c5e049fa8078171700171b",
          is_local: false,
          mimetype: "image/jpeg",
          path: "https://monmi.hn.ss.bfcplatform.vn/merchants/61c5e049fa8078171700171b/1640358114908-1.jpg",
          name: "1.jpg",
          created_at: "2021-12-24T15:01:55.179Z",
          updated_at: "2021-12-24T15:01:55.179Z",
          id: "61c5e0e3fa80781717001754"
        },
        images: [],
        id: "61c5e0e4fa8078171700175b"
      },
      merchant: {
        slug: "phat-lac-long-quan-phuong-12-quan-tan-binh-ho-chi-minh-1640357961557",
        deliveries: [],
        location: {
          position: {type: "Point", coordinates: [106.6474366, 10.7740344]},
          lat: 10.818241,
          long: 106.723344,
          address: "lac long quan ",
          province_name: "Hồ Chí Minh",
          district_name: "Quận Tân Bình",
          ward_name: "Phường 12",
          ward_id: 21412,
          district_id: 1455,
          province_id: 202,
          created_at: "2021-12-24T14:59:21.562Z",
          updated_at: "2021-12-24T14:59:21.562Z"
        },
        status: 1,
        is_verified: 1,
        description: "phat",
        phone: "+614848494945",
        email: "vcs.epis@gmail.com",
        name: "phat",
        created_at: "2021-12-24T14:59:21.563Z",
        updated_at: "2021-12-24T14:59:21.700Z",
        code: 44,
        merchant_id: "61c5e049fa8078171700171b",
        image: null,
        categories: [{
          slug: "hus-1640358095978",
          merchant_id: "61c5e049fa8078171700171b",
          status: 1,
          image_ids: [],
          description: "h",
          name: "hus",
          is_deleted: false,
          deleted_at: null,
          created_at: "2021-12-24T15:01:35.979Z",
          updated_at: "2021-12-24T15:01:35.979Z",
          code: 22,
          products: [{
            slug: "phatss",
            merchant_id: "61c5e049fa8078171700171b",
            category_id: "61c5e0cffa80781717001746",
            price: 100000,
            status: 1,
            image_id: "61c5e0e3fa80781717001754",
            image_ids: [],
            description: "ohatfb",
            name: "phatss",
            created_at: "2021-12-24T15:01:56.916Z",
            updated_at: "2021-12-24T15:01:56.916Z",
            code: 44,
            image: {
              merchant_id: "61c5e049fa8078171700171b",
              is_local: false,
              mimetype: "image/jpeg",
              path: "https://monmi.hn.ss.bfcplatform.vn/merchants/61c5e049fa8078171700171b/1640358114908-1.jpg",
              name: "1.jpg",
              created_at: "2021-12-24T15:01:55.179Z",
              updated_at: "2021-12-24T15:01:55.179Z",
              id: "61c5e0e3fa80781717001754"
            },
            images: [],
            id: "61c5e0e4fa8078171700175b"
          }],
          images: [],
          id: "61c5e0cffa80781717001746"
        }],
        id: "456"
      },
      qty: 2
    },
    {
      product: {
        slug: "phatss",
        merchant_id: "61c5e049fa8078171700171b",
        category_id: "61c5e0cffa80781717001746",
        price: 100000,
        status: 1,
        image_id: "61c5e0e3fa80781717001754",
        image_ids: [],
        description: "ohatfb",
        name: "Sản phẩm 2 shop 2",
        created_at: "2021-12-24T15:01:56.916Z",
        updated_at: "2021-12-24T15:01:56.916Z",
        code: 44,
        image: {
          merchant_id: "61c5e049fa8078171700171b",
          is_local: false,
          mimetype: "image/jpeg",
          path: "https://monmi.hn.ss.bfcplatform.vn/merchants/61c5e049fa8078171700171b/1640358114908-1.jpg",
          name: "1.jpg",
          created_at: "2021-12-24T15:01:55.179Z",
          updated_at: "2021-12-24T15:01:55.179Z",
          id: "61c5e0e3fa80781717001754"
        },
        images: [],
        id: "61c5e0e4fa8078171700175b"
      },
      merchant: {
        slug: "phat-lac-long-quan-phuong-12-quan-tan-binh-ho-chi-minh-1640357961557",
        deliveries: [],
        location: {
          position: {type: "Point", coordinates: [106.6474366, 10.7740344]},
          lat: 10.818241,
          long: 106.723344,
          address: "lac long quan ",
          province_name: "Hồ Chí Minh",
          district_name: "Quận Tân Bình",
          ward_name: "Phường 12",
          ward_id: 21412,
          district_id: 1455,
          province_id: 202,
          created_at: "2021-12-24T14:59:21.562Z",
          updated_at: "2021-12-24T14:59:21.562Z"
        },
        status: 1,
        is_verified: 1,
        description: "phat",
        phone: "+614848494945",
        email: "vcs.epis@gmail.com",
        name: "phat",
        created_at: "2021-12-24T14:59:21.563Z",
        updated_at: "2021-12-24T14:59:21.700Z",
        code: 44,
        merchant_id: "61c5e049fa8078171700171b",
        image: null,
        categories: [{
          slug: "hus-1640358095978",
          merchant_id: "61c5e049fa8078171700171b",
          status: 1,
          image_ids: [],
          description: "h",
          name: "hus",
          is_deleted: false,
          deleted_at: null,
          created_at: "2021-12-24T15:01:35.979Z",
          updated_at: "2021-12-24T15:01:35.979Z",
          code: 22,
          products: [{
            slug: "phatss",
            merchant_id: "61c5e049fa8078171700171b",
            category_id: "61c5e0cffa80781717001746",
            price: 100000,
            status: 1,
            image_id: "61c5e0e3fa80781717001754",
            image_ids: [],
            description: "ohatfb",
            name: "phatss",
            created_at: "2021-12-24T15:01:56.916Z",
            updated_at: "2021-12-24T15:01:56.916Z",
            code: 44,
            image: {
              merchant_id: "61c5e049fa8078171700171b",
              is_local: false,
              mimetype: "image/jpeg",
              path: "https://monmi.hn.ss.bfcplatform.vn/merchants/61c5e049fa8078171700171b/1640358114908-1.jpg",
              name: "1.jpg",
              created_at: "2021-12-24T15:01:55.179Z",
              updated_at: "2021-12-24T15:01:55.179Z",
              id: "61c5e0e3fa80781717001754"
            },
            images: [],
            id: "61c5e0e4fa8078171700175b"
          }],
          images: [],
          id: "61c5e0cffa80781717001746"
        }],
        id: "456"
      },
      qty: 1
    },
    {
      product: {
        slug: "phatss",
        merchant_id: "61c5e049fa8078171700171b",
        category_id: "61c5e0cffa80781717001746",
        price: 100000,
        status: 1,
        image_id: "61c5e0e3fa80781717001754",
        image_ids: [],
        description: "ohatfb",
        name: "Sản phẩm 1 shop 3",
        created_at: "2021-12-24T15:01:56.916Z",
        updated_at: "2021-12-24T15:01:56.916Z",
        code: 44,
        image: {
          merchant_id: "61c5e049fa8078171700171b",
          is_local: false,
          mimetype: "image/jpeg",
          path: "https://monmi.hn.ss.bfcplatform.vn/merchants/61c5e049fa8078171700171b/1640358114908-1.jpg",
          name: "1.jpg",
          created_at: "2021-12-24T15:01:55.179Z",
          updated_at: "2021-12-24T15:01:55.179Z",
          id: "61c5e0e3fa80781717001754"
        },
        images: [],
        id: "61c5e0e4fa8078171700175b"
      },
      merchant: {
        slug: "phat-lac-long-quan-phuong-12-quan-tan-binh-ho-chi-minh-1640357961557",
        deliveries: [],
        location: {
          position: {type: "Point", coordinates: [106.6474366, 10.7740344]},
          lat: 10.818241,
          long: 106.723344,
          address: "lac long quan ",
          province_name: "Hồ Chí Minh",
          district_name: "Quận Tân Bình",
          ward_name: "Phường 12",
          ward_id: 21412,
          district_id: 1455,
          province_id: 202,
          created_at: "2021-12-24T14:59:21.562Z",
          updated_at: "2021-12-24T14:59:21.562Z"
        },
        status: 1,
        is_verified: 1,
        description: "phat",
        phone: "+614848494945",
        email: "vcs.epis@gmail.com",
        name: "phat",
        created_at: "2021-12-24T14:59:21.563Z",
        updated_at: "2021-12-24T14:59:21.700Z",
        code: 44,
        merchant_id: "61c5e049fa8078171700171b",
        image: null,
        categories: [{
          slug: "hus-1640358095978",
          merchant_id: "61c5e049fa8078171700171b",
          status: 1,
          image_ids: [],
          description: "h",
          name: "hus",
          is_deleted: false,
          deleted_at: null,
          created_at: "2021-12-24T15:01:35.979Z",
          updated_at: "2021-12-24T15:01:35.979Z",
          code: 22,
          products: [{
            slug: "phatss",
            merchant_id: "61c5e049fa8078171700171b",
            category_id: "61c5e0cffa80781717001746",
            price: 100000,
            status: 1,
            image_id: "61c5e0e3fa80781717001754",
            image_ids: [],
            description: "ohatfb",
            name: "phatss",
            created_at: "2021-12-24T15:01:56.916Z",
            updated_at: "2021-12-24T15:01:56.916Z",
            code: 44,
            image: {
              merchant_id: "61c5e049fa8078171700171b",
              is_local: false,
              mimetype: "image/jpeg",
              path: "https://monmi.hn.ss.bfcplatform.vn/merchants/61c5e049fa8078171700171b/1640358114908-1.jpg",
              name: "1.jpg",
              created_at: "2021-12-24T15:01:55.179Z",
              updated_at: "2021-12-24T15:01:55.179Z",
              id: "61c5e0e3fa80781717001754"
            },
            images: [],
            id: "61c5e0e4fa8078171700175b"
          }],
          images: [],
          id: "61c5e0cffa80781717001746"
        }],
        id: "789"
      },
      qty: 3
    }
  ],
  timeUTV7  : {
    "1" : "08",
    "2" : "09",
    "3" : "10",
    "4" : "11",
    "5" : "12",
    "6" : "13",
    "7" : "14",
    "8" : "15",
    "9" : "16",
    "10" : "17",
    "11" : "18",
    "12" : "19",
    "13" : "20",
    "14" : "21",
    "15" : "22",
    "16" : "23",
    "17" : "24",
    "18" : "01",
    "19" : "02",
    "20" : "03",
    "21" : "04",
    "22" : "05",
    "23" : "06",
    "24" : "07",
  },
}



// WEBPACK FOOTER //
// ./src/constants/config.js